// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"G3-z","colorTextValue":"H3-z","swatches":"I3-z","collapseLink":"J3-z","isCollapsed":"K3-z","dropdown":"L3-z","disabled":"M3-z"};